import {
  Box,
  Divider,
  Tab,
  Tabs,
  Typography,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import React, { useState } from "react";
import { useQuery } from "react-query";
import fetcher from "../../api/swr_fetcher";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import ScrollFade from "@benestudioco/react-scrollfade";
import { useSelector } from "react-redux";
import Button from "@material-ui/core/Button";
import { useDialog } from "../../contexts/DialogProvider";
import Img from "react-cool-img";
import useResizer from "../../services/useResizer";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

export default function BonusTable() {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className="w-full sm:max-w-xl md:max-w-[800px] lg:max-w-[900px] bg-[#282C37]  rounded-[12px] overflow-hidden">
      <Tabs
        value={value}
        variant="fullWidth"
        indicatorColor="primary"
        onChange={handleChange}
        aria-label="simple tabs example"
      >
        <Tab label="Bonus" className="font-bold capitalize" />
        <Tab label="Bonus History" className="font-bold capitalize" />
      </Tabs>

      {value == 0 ? (
        <TabPanel value={0} index={0}>
          <BonusStats></BonusStats>
          <Bonus value={value}></Bonus>
        </TabPanel>
      ) : (
        <TabPanel value={1} index={1}>
          <BonusStats></BonusStats>
          <BonusHistory value={value}></BonusHistory>
        </TabPanel>
      )}
    </div>
  );
}

const BonusStats = () => {
  const bonusStats = useQuery(["bonusStats"], () =>
    fetcher("/v1/bonus/stats").then((res) => res)
  );

  return (
    <>
      <div className=" gap-10 flex-wrap items-center px-4 sm:flex hidden">
        <div className="flex items-center gap-1">
          <h5 className="font-light opacity-70">Locked Bonus</h5>
          <h5 className="bg-[#1B202D] py-1 px-4 rounded-md">
            ₹{bonusStats.data?.lockedBonus || "0"}
          </h5>
        </div>
        <div className="flex items-center gap-1">
          <h5 className="font-light opacity-70">Earned Bonus</h5>
          <h5 className="bg-[#1B202D] py-1 px-4 rounded-md">
            ₹{bonusStats.data?.earnedBonus || "0"}
          </h5>
        </div>
      </div>
      <Divider className="mt-3 sm:block hidden"></Divider>
    </>
  );
};

const Bonus = ({ value }) => {
  const bonusActive = useQuery(["bonusActive"], () =>
    fetcher("/v1/bonus/active").then((res) => res)
  );

  return (
    <div>
      {bonusActive.isSuccess && (
        <BonusTableWrapper
          value={value}
          data={bonusActive.data}
        ></BonusTableWrapper>
      )}
    </div>
  );
};

const BonusHistory = ({ value }) => {
  const bonusHistory = useQuery(["bonusHistory"], () =>
    fetcher("/v1/bonus/history").then((res) => res)
  );
  return (
    <div>
      {bonusHistory.isSuccess && (
        <BonusTableWrapper
          data={bonusHistory.data}
          value={value}
        ></BonusTableWrapper>
      )}
    </div>
  );
};

const BonusTableWrapper = ({ data, row, type, value }) => {
  const coinIcons = useSelector((state) => state.trading.COIN_ICONS);
  const classes = useStyles();
  const [openDialog, closeDialog] = useDialog();
  const isMobile = useResizer();

  const handleRedeem = (text) => {
    openDialog({
      children: (
        <div className="max-w-[340px]">
          <DialogContent className="pb-2">
            <Typography className="">
              <p>{text}</p>
            </Typography>
          </DialogContent>
          <DialogActions className="px-4 mb-4">
            <Button
              onClick={closeDialog}
              disableElevation
              className="w-full"
              type="submit"
              variant="contained"
              color="primary"
              style={{ color: "white", fontWeight: "bold" }}
            >
              OK
            </Button>
          </DialogActions>{" "}
        </div>
      ),
    });
  };
  return isMobile ? (
    data.length > 0 ? (
      <div style={{ maxHeight: 330, overflowY: "auto" }} className="w-full">
        <div className="flex items-center justify-between w-full px-4 text-[#A6ABB9]">
          <div className="w-1/3">
            <h6>COIN</h6>
          </div>
          <div className="w-1/3 text-center -ml-8">
            <h6>VALUE</h6>
          </div>
          <div className="w-1/3 text-center">
            <h6>STATUS</h6>
          </div>
        </div>
        <Divider className="my-3"></Divider>
        <div>
          {data?.map((row, idx) => {
            const currentCoin = coinIcons[row.coinId];

            return (
              <Accordion
                classes={{
                  root: classes.rootAccordion,
                }}
                disableGutters
                elevation={0}
                className="bg-[#282C37] border-none"
                style={{ boxShadow: "none" }}
              >
                <AccordionSummary
                  classes={{
                    expanded: classes.expandedAccordionSummary,
                  }}
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <div className="w-full flex items-center text-xs ">
                    <div className="w-1/3">
                      <div className="flex gap-x-3 ">
                        <img
                          src={currentCoin?.activeIconUrl}
                          height="auto"
                          width={20}
                          alt={currentCoin}
                        />

                        <div className="flex gap-2 items-center">
                          <p className="sm:text-[#66696F] ">
                            {currentCoin?.coinId}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="w-1/3 text-center">
                      <p> ₹{row.valueInInr}</p>
                    </div>
                    <div className="w-1/3 text-center flex justify-end ">
                      {row.status === "TO_BE_REDEEMED" ? (
                        <Button
                          variant="contained"
                          color="primary"
                          className="font-bold text-xs text-white capitalize"
                          size="small"
                          onClick={() =>
                            handleRedeem(row.message || "Contact Support")
                          }
                        >
                          Redeem
                        </Button>
                      ) : (
                        <div className="flex items-center gap-2 justify-end">
                          <p>Redeemed</p>
                          <Img
                            className=""
                            src={require("../../assets/svgs/tick.svg").default}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </AccordionSummary>
                <AccordionDetails
                  classes={{
                    root: classes.rootAccordionDetails,
                  }}
                  style={{
                    boxShadow: "none",
                    background: "rgba(255, 250, 250, 0.06)",
                    width: "100%",
                  }}
                >
                  <div className="w-full text-sm text-[#BABBBF] leading-relaxed">
                    <div className="flex justify-between w-full">
                      <p>Quantity</p>
                      <p>
                        {" "}
                        {row.quantity} {currentCoin?.coinId}
                      </p>
                    </div>
                    {row.type?.length > 0 && (
                      <div className="flex justify-between">
                        <p>Type</p>
                        <p> {row.type} </p>
                      </div>
                    )}
                  </div>
                </AccordionDetails>
              </Accordion>
            );
          })}
        </div>
        <ScrollFade></ScrollFade>
      </div>
    ) : value == 0 ? (
      <NoBonus />
    ) : (
      <NoBonusHistory></NoBonusHistory>
    )
  ) : data.length > 0 ? (
    <TableContainer style={{ maxHeight: 330, overflowY: "auto" }}>
      <Table className={classes.table} stickyHeader>
        <TableHead className="border-none">
          <TableRow>
            <StyledTableCell className="font-bold text-xs ">
              COIN
            </StyledTableCell>
            {!isMobile && (
              <StyledTableCell align="right" className="font-bold text-xs">
                QUANTITY
              </StyledTableCell>
            )}

            <StyledTableCell
              align={isMobile ? "left" : "right"}
              className="font-bold text-xs"
            >
              VALUE
            </StyledTableCell>
            {!isMobile && (
              <StyledTableCell align="right" className="font-bold text-xs">
                TYPE
              </StyledTableCell>
            )}

            <StyledTableCell align="right" className="font-bold text-xs">
              STATUS
            </StyledTableCell>
          </TableRow>
        </TableHead>

        <TableBody className="w-full">
          {data?.map((row, idx) => {
            const currentCoin = coinIcons[row.coinId];

            return (
              <StyledTableRow key={idx}>
                <StyledTableCell
                  component="th"
                  scope="row"
                  className="w-[10px]"
                >
                  <div className="flex gap-x-3 ">
                    <img
                      src={currentCoin?.activeIconUrl}
                      height="auto"
                      width={26}
                      alt={currentCoin}
                    />

                    <div className="flex gap-2 items-center">
                      <p className="sm:block hidden">{currentCoin?.coinName}</p>
                      <p className="sm:text-[#66696F]">{currentCoin?.coinId}</p>
                    </div>
                  </div>
                </StyledTableCell>
                {!isMobile && (
                  <StyledTableCell align="right">
                    {row.quantity} {currentCoin?.coinId}
                  </StyledTableCell>
                )}
                <StyledTableCell
                  align={isMobile ? "left" : "right"}
                  className="w-[40px]"
                >
                  ₹{row.valueInInr}
                </StyledTableCell>
                {!isMobile && (
                  <StyledTableCell align="right" className="capitalize">
                    {row.type}
                  </StyledTableCell>
                )}
                <StyledTableCell align="right" className="w-[40px]">
                  {row.status === "TO_BE_REDEEMED" ? (
                    <Button
                      variant="contained"
                      color="primary"
                      className="font-bold text-xs text-white capitalize"
                      size="small"
                      onClick={() =>
                        handleRedeem(row.message || "Contact Support")
                      }
                    >
                      Redeem
                    </Button>
                  ) : (
                    <div className="flex items-center gap-2 justify-end">
                      <p>Redeemed</p>
                      <Img
                        className=""
                        src={require("../../assets/svgs/tick.svg").default}
                      />
                    </div>
                  )}
                </StyledTableCell>
              </StyledTableRow>
            );
          })}
        </TableBody>
      </Table>
      <ScrollFade></ScrollFade>
    </TableContainer>
  ) : value == 0 ? (
    <NoBonus />
  ) : (
    <NoBonusHistory></NoBonusHistory>
  );
};

const NoBonus = () => (
  <div className="my-8 flex justify-center items-center w-full">
    <div className="flex flex-col justify-center items-center gap-4">
      <Img
        className="min-w-[100px]  max-w-[100px]"
        src={require("../../assets/svgs/no-bonus.svg").default}
      />
      <p className="text-sm  text-center text-[#B8C6D8]">
        {" "}
        Keep an eye out here so you don’t <br></br> miss out on any bonuses!
      </p>
    </div>
  </div>
);
const NoBonusHistory = () => (
  <div className="my-8 flex justify-center items-center w-full">
    <div className="flex flex-col justify-center items-center gap-4">
      <Img
        className="min-w-[100px] max-w-[100px]"
        src={require("../../assets/svgs/no-bonus-history.svg").default}
      />
      <p className="text-sm text-[#B8C6D8]">No bonus history yet !</p>
    </div>
  </div>
);
const StyledTableCell = withStyles((theme) => ({
  root: {
    borderBottom: "none",
  },
  head: {
    backgroundColor: "#282C37",
    color: "#A6ABB9",
    border: "none",
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: "#C4C4C40F",
      border: "none",
    },
  },
}))(TableRow);

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box py={2}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const useStyles = makeStyles({
  table: {
    minWidth: 700,
  },
  rootAccordion: {
    margin: "0 !important",
  },
  expandedAccordionSummary: {
    // margin: "0 !important",
  },
  rootAccordionDetails: {
    padding: "16px !important",
  },
});
